import store from '../store/store';

export default function getBookingMailbox(): string {
    return store.bookingMailbox ?? '';
}
